import script from "./RecentSearches.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecentSearches.vue?vue&type=script&setup=true&lang=ts"

import "./RecentSearches.vue?vue&type=style&index=0&id=7ac2d5d8&lang=scss"

const __exports__ = script;

export default __exports__